
import { AppContext } from '../context/AppContext';
import { useContext } from 'react'
import DashboardSr from '../components/DashboardSr';
import DashboardUser from '../components/DashboardUser';
import DashboardAccountant from '../components/DashboardAccountant';
import DashboardSalesDirector from '../components/DashboardSalesDirector';
import DashboardSalesAdmin from '../components/DashboardSalesAdmin';
import DashboardStoreManager from '../components/DashboardStoreManager';


const Dashboard = () => {

	const { currentUser } = useContext(AppContext);
	// console.log(currentUser)

	return (
		<>
			{currentUser !== undefined ? ( // Check if currentUser exists
				currentUser.id_roles === 1 ? ( // Check for Sales Representative
					<DashboardSr />
				) : currentUser.id_roles === 2 ? ( // Check for Sales Admin
					<DashboardSalesAdmin />
				) : currentUser.id_roles === 3 ? ( // Check for Sales Director
					<DashboardSalesDirector />
				) : currentUser.id_roles === 6 ? ( // Check for Accountant role
					<DashboardAccountant />
				) : currentUser.id_roles === 13 ? ( // Check for Accountant role
					<DashboardStoreManager />
				) : (
					<DashboardUser /> // Default for other roles
				)
			) : (
				<h1 className='pt-10 text-center'>Loading...</h1>
			)}
		</>
	)
}

export default Dashboard
